export default {
    numeroReservasNoConfirmadas(state) {
        return state.reservasNoConfirmada.length
    }
}